// Define route paths centrally to avoid hardcoding
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  GENERATE: '/generate',
  VISITOR_PROPOSAL_PREVIEW: '/visitor-proposals/:visitorProposalId',
  DASHBOARD: '/dashboard',
  TEMPLATES: '/templates',
  PROPOSAL_EDITOR: '/proposal-editor',
  PROPOSAL_TIMELINE: '/proposals/:proposalId',
  PROPOSAL_EDIT: '/proposals/:proposalId/edit',
  PROPOSAL_PREVIEW: '/proposals/:proposalId/preview',
  PROPOSALS_DRAFTS: '/proposals/drafts',
  PROPOSALS_SENT: '/proposals/sent',
  PROPOSALS_SIGNED: '/proposals/signed',
  PROPOSALS_INDEX: '/proposals',
  PUBLIC_PROPOSAL: '/p/:token',
  // FEATURES: '/features',
  // PRICING: '/pricing',
  UNAUTHORIZED: '/unauthorized',
  CLIENTS: '/clients',
  CLIENT_DETAIL: '/clients/:clientId',
  ACCOUNT_SETTINGS: '/account/settings',
  ACCOUNT_USERS: '/account/users',
};

export const buildProposalTimelineRoute = (proposalId: string) => `/proposals/${proposalId}`;
export const buildProposalEditRoute = (proposalId: string) => `/proposals/${proposalId}/edit`;
export const buildProposalPreviewRoute = (proposalId: string) => `/proposals/${proposalId}/preview`;
export const resolveProposalOpenMode = (status?: string | null): 'edit' | 'preview' => {
  return status?.toLowerCase() === 'draft' ? 'edit' : 'preview';
};
export const buildOpenProposalRoute = (proposalId: string, status?: string | null) =>
  resolveProposalOpenMode(status) === 'edit'
    ? buildProposalEditRoute(proposalId)
    : buildProposalPreviewRoute(proposalId);
export const buildClientDetailRoute = (clientId: string) => `/clients/${clientId}`;

// Default redirect route for authenticated users
export const DEFAULT_AUTHENTICATED_ROUTE = ROUTES.DASHBOARD;

// Default redirect route for unauthenticated users
export const DEFAULT_UNAUTHENTICATED_ROUTE = ROUTES.LOGIN;
